import { handleActions } from "redux-actions";

import { removeById, updateById } from "utils";

const companyUserReducer = handleActions(
  {
    COMPANY_ACCESS_REQUEST_GET_ALL: {
      FULFILLED: (_state, { payload }) => ({
        companyAccessRequests: payload.companyAccessRequests,
      }),
    },

    COMPANY_ACCESS_REQUEST_ACCEPT: {
      FULFILLED: ({ companyAccessRequests }, { meta }) => ({
        companyAccessRequests: removeById(companyAccessRequests, meta.id),
      }),
    },

    COMPANY_ACCESS_REQUEST_REJECT: {
      FULFILLED: ({ companyAccessRequests }, { payload }) => ({
        companyAccessRequests: updateById(companyAccessRequests, payload.companyAccessRequest),
      }),
    },

    COMPANY_ACCESS_REQUEST_CREATE: {
      FULFILLED: ({ companyAccessRequests }, { payload }) => ({
        companyAccessRequests: [...companyAccessRequests, payload.companyAccessRequest],
      }),
    },
  },
  {},
  { namespace: "_" }
);

export default companyUserReducer;
